export const stationEn = {
  // 标题
  title: 'Stations',
  management: 'Station Management',
  list: 'Station List',
  create: 'Create Station',
  edit: 'Edit Station',
  detail: 'Station Details',

  // 字段
  code: 'Station Code',
  nameEn: 'English Name',
  nameCn: 'Chinese Name',
  description: 'Description',
  area: 'Area/Workshop',
  line: 'Production Line',
  type: 'Station Type',
  status: 'Status',
  sortOrder: 'Sort Order',
  partsCount: 'Parts Count',
  createdAt: 'Created At',
  updatedAt: 'Updated At',

  // 状态
  statusOptions: {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    MAINTENANCE: 'Maintenance',
  },

  // 占位符
  placeholder: {
    code: 'Enter station code',
    nameEn: 'Enter English name',
    nameCn: 'Enter Chinese name',
    description: 'Enter description',
    area: 'Select or enter area',
    line: 'Select or enter line',
    type: 'Select or enter type',
    search: 'Search station code or name...',
  },

  // 操作
  actions: {
    create: 'Create Station',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    import: 'Bulk Import',
    export: 'Export',
    downloadTemplate: 'Download Template',
  },

  // 消息
  messages: {
    loadFailed: 'Failed to load stations',
    createSuccess: 'Station created successfully',
    createFailed: 'Failed to create station',
    updateSuccess: 'Station updated successfully',
    updateFailed: 'Failed to update station',
    deleteSuccess: 'Station deleted successfully',
    deleteFailed: 'Failed to delete station',
    deleteConfirm: 'Are you sure you want to delete station {code}?',
    hasPartsError: 'Cannot delete station with associated parts',
    codeExists: 'Station code already exists',
    importSuccess: 'Successfully imported {count} stations',
    importFailed: 'Failed to import {count} stations',
    importPartialSuccess: 'Imported {success} stations, failed {failed}',
  },

  // 导入
  import: {
    title: 'Bulk Import Stations',
    description: 'Upload CSV file to import stations in bulk',
    downloadTemplate: 'Download Template',
    selectFile: 'Select File',
    uploading: 'Importing...',
    result: 'Import Result',
    success: 'Success',
    failed: 'Failed',
    errors: 'Error Details',
    row: 'Row',
    errorMessage: 'Error Message',
  },

  // 筛选
  filter: {
    all: 'All',
    allAreas: 'All Areas',
    allLines: 'All Lines',
    allTypes: 'All Types',
    allStatus: 'All Status',
  },

  // 空状态
  empty: {
    title: 'No Stations',
    description: 'Click the button above to create your first station',
  },

  // 表格
  table: {
    code: 'Code',
    name: 'Name',
    area: 'Area',
    line: 'Line',
    type: 'Type',
    status: 'Status',
    partsCount: 'Parts',
    actions: 'Actions',
  },
};

